module.exports = __webpack_public_path__ + "img/buy_normal_th.76a5a473.png";